<template>
  <div class="page">
    <LabelContent ref="LabelContent" title="基本信息"></LabelContent>
    <SearchBox ref="SearchBox">
      <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="115px" class="unitWidth" size="small">
        <el-col :span="6">
          <el-form-item label="安灯订单编号">
            <el-input v-model="searchParams.andonCode" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="所属工厂">
            <el-select v-model="fcIdSelected" placeholder="请选择所属工厂(必填)" :disabled="orgShow">
              <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label" :value="factory.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="所属车间">
            <el-select v-model="shopSelected" placeholder="请选择所属车间(必填)" :disabled="orgShow" filterable @change="shopChange">
              <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label" :value="shop.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="所属工段">
            <el-select v-model="sectionSelected" placeholder="请选择所属工段(必填)" :disabled="orgShow" filterable @change="sectionChange">
              <el-option v-for="section in sectionList" :key="section.value" :label="section.label" :value="section.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="所属产线">
            <el-select v-model="lineSelected" placeholder="请选择所属产线(必填)" :disabled="orgShow" filterable>
              <el-option v-for="line in lineList" :key="line.value" :label="line.label" :value="line.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="设备编号">
            <!--<el-input v-model="searchParams.devCode" placeholder="请输入设备编号(必填)"  :disabled="editShow" @blur="queryDevCode">
                        </el-input>-->
            <el-select v-model="searchParams.devCode" placeholder="请选择设备编号" clearable filterable :disabled="editShow" @change="queryDevCode">
              <el-option v-for="dev in deviceInfoList" :key="dev.devCode" :label="dev.devCode" :value="dev.devCode"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="设备名称">
            <!--deviceInfoList-->
            <el-input v-model.trim="searchParams.devName" placeholder="请输入设备名称" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安灯状态">
            <el-select v-model="searchParams.andonStatus" :disabled="true">
              <el-option label="待接单" value="create"></el-option>
              <el-option label="待完成" value="wait_complete"></el-option>
              <el-option label="待验收" value="wait_accept"></el-option>
              <el-option label="已完成" value="complete"></el-option>
            </el-select>
            <!--<span v-if="searchParams.andonStatus == 'create'">待接单</span>
                        <span v-if="searchParams.andonStatus == 'wait_complete'">待处理</span>
                        <span v-if="searchParams.andonStatus == 'wait_accept'">待验收</span>
                        <span v-if="searchParams.andonStatus == 'complete'">已完成</span>-->
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安灯类型">
            <!--                        <el-input v-model="searchParams.atName"  :disabled="editShow"></el-input>-->
            <el-select v-model="aTypeSelected" placeholder="请选择安灯类型(必填)" clearable filterable :disabled="editShow" @change="aTChange">
              <el-option v-for="atype in aTList" :key="atype.id" :label="atype.label" :value="JSON.stringify(atype.value)">
                <span style="float: left">{{ atype.label }}</span>
                <span v-if="atype.value.hasOwnProperty('contentList')" style="float: right; color: #8492a6; font-size: 13px"> ({{ atype.value.contentList.length }}) </span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安灯种类">
            <!--                        <el-input v-model="searchParams.acName"  :disabled="editShow"></el-input>-->
            <el-select v-model="aCSelected" placeholder="请选择安灯种类(必填)" clearable filterable :disabled="editShow" @change="aCChange">
              <el-option v-for="acontent in aCList" :key="acontent.id" :label="acontent.label" :value="acontent.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安灯规则">
            <!--                        <el-input-number v-model="searchParams.andonInitLevel" :min="0" :disabled="editShow"></el-input-number>-->
            <!--                        <el-input v-model="searchParams.arTrigger"  :disabled="editShow"></el-input>-->
            <el-select v-model="searchParams.arId" placeholder="请选择安灯规则(必填)" clearable filterable :disabled="editShow" @change="ruleTriggerChange">
              <el-option v-for="rule in ruleTriggerList" :key="rule.arId" :label="rule.arTrigger" :value="rule.arId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安灯初始级别">
            <!--                        <el-input-number v-model="searchParams.andonInitLevel" :min="0" :disabled="editShow"></el-input-number>-->
            <el-input v-model.trim="searchParams.andonInitLevel" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安灯当前级别">
            <!--                        <el-input-number v-model="searchParams.arLevel" :min="0" :disabled="editShow"></el-input-number>-->
            <el-input v-model="searchParams.arLevel" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发布人">
            <el-input v-model.trim="searchParams.pubUserName" placeholder="请输入发布人" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="接单人">
            <el-input v-model.trim="searchParams.andonRespUserName" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发布时间">
            <el-date-picker v-model="searchParams.createTime" placeholder="请选择发布时间(必填)" type="datetime" :disabled="editShow"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="接单时间">
            <el-date-picker v-model="searchParams.andonRespTime" type="datetime" :disabled="editShow"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="维修开始时间">
            <el-date-picker v-model="searchParams.moRepairStart" type="datetime" :disabled="editShow"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="维修结束时间">
            <el-date-picker v-model="searchParams.moRepairEnd" type="datetime" :disabled="editShow"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安灯关闭时间">
            <el-date-picker v-model="searchParams.andonCloseTime" type="datetime" :disabled="true"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="故障总时长(分)">
            <el-input v-model="searchParams.moProbTime" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="实际时长(分)">
            <el-input v-model="searchParams.moAdjustProdTime" :disabled="editShow"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="协助人员一">
            <el-input v-model.trim="searchParams.morAssistOne" :disabled="editShow"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="协助人员二">
            <el-input v-model.trim="searchParams.morAssistTwo" :disabled="editShow"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="协助人员三">
            <el-input v-model.trim="searchParams.morAssistThree" :disabled="editShow"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="原因分类">
            <el-input v-model.trim="searchParams.aorReasonType" :disabled="editShow"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="紧急措施类型">
            <el-input v-model.trim="searchParams.empActionType" :disabled="editShow"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" style="display: flex">
          <el-form-item style="display: flex" label="安灯退回原因">
            <el-input v-model.trim="searchParams.andonRejectReason" :disabled="editShow"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否遏制">
            <el-switch v-model="searchParams.aorIsContain" active-text="是" inactive-text="否" :disabled="editShow"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="采取紧急措施">
            <el-switch v-model="searchParams.empActionConfirm" active-text="是" inactive-text="否" :disabled="editShow"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="是否供应商支持">
            <el-switch v-model="searchParams.morIsSupport" active-text="是" inactive-text="否" :disabled="editShow"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item style="display: flex" label="问题产生类型">
            <el-col :span="6">
              <div style="display: flex">
                <span style="display: flex; justify-content: center">Ⅰ：</span>
                <el-select v-model="faultTreeOneText" @change="faultTreeOneValues" placeholder="请选择故障代码" :disabled="editShow" filterable>
                  <el-option v-for="line in faultTreeOne" :key="line.grandpacode" :label="line.grandpaname" :value="line.value"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="margin-left: 4.3vw; display: flex">
                <span style="display: flex; justify-content: center">Ⅱ：</span>
                <el-select v-model="faultTreeTwoText" @change="faultTreeTwoValues" placeholder="请选择故障代码" :disabled="editShow" filterable>
                  <el-option v-for="line in faultTreeTwo" :key="line.grandpacode" :label="line.grandpaname" :value="line.value"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="margin-left: 8.5vw; display: flex">
                <span style="display: flex; justify-content: center">Ⅲ：</span>
                <el-select v-model="faultTreethreeText" @change="faultTreethreeValues" placeholder="请选择故障代码" :disabled="editShow" filterable>
                  <el-option v-for="line in faultTreethree" :key="line.grandpacode" :label="line.grandpaname" :value="line.grandpacode"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="5">
              <span style="position: relative; left: 8vw">故障代码:{{ faultCode }}</span>
            </el-col>
          </el-form-item>
        </el-col>
      </el-form>
      <el-form style="background-color: red" slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="115px" class="unitWidth" size="small">
        <!--<el-col :span="14" style="display: flex">
                    <el-form-item style="display: flex" label="原因分析描述">
                        <el-input type="textarea" rows="4" v-model.trim="searchParams.analyzingDesc" :disabled="editShow"></el-input>
                    </el-form-item>
                </el-col>-->
        <el-col :span="14" style="display: flex">
          <el-form-item style="display: flex" label="问题描述">
            <el-input type="textarea" rows="4" v-model.trim="searchParams.andonProbDesc" placeholder="请输入问题描述" :disabled="editShow"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="14" style="display: flex">
          <el-form-item style="display: flex" label="处理对策描述">
            <el-input type="textarea" rows="4" v-model.trim="searchParams.aorSolveDesc" :disabled="editShow"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="14" style="display: flex">
                    <el-form-item label="紧急措施描述">
                        <el-input type="textarea" rows="4" v-model.trim="searchParams.empActionDesc" :disabled="editShow"></el-input>
                    </el-form-item>
                </el-col> -->
        <el-col :span="18">
          <el-col :span="6">
            <el-form-item label="现场图片">
              <div style="width: 10vw" v-if="picList.length != 0" v-for="pic in picList">
                <ul style="float: left; padding: 10px">
                  <li>
                    <el-popover placement="left" trigger="click" width="500">
                      <img :src="pic" width="100%" />
                      <img slot="reference" :src="pic" :alt="pic" style="max-height: 50px; max-width: 50px; padding: 5px" />
                    </el-popover>
                  </li>
                </ul>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="处理图片">
              <div style="width: 10vw" v-if="imgSList.length != 0" v-for="pic in imgSList">
                <ul style="float: left; padding: 10px">
                  <li>
                    <el-popover placement="left" trigger="click" width="500">
                      <img :src="pic" width="100%" />
                      <img slot="reference" :src="pic" :alt="pic" style="max-height: 50px; max-width: 50px; padding: 5px" />
                    </el-popover>
                  </li>
                </ul>
              </div>
              <!--<div style="width:10vw;" v-if="imgSList.length != 0" v-for="pic in imgSList">
                            <el-popover placement="left" trigger="click" width="300">
                                <img :src="pic" width="100%" />
                                <img
                                    slot="reference"
                                    :src="pic"
                                    :alt="pic"
                                    style="max-height: 70px;max-width: 70px; padding: 5px"
                                />
                            </el-popover>
                        </div>-->
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button type="primary" @click="editAndonOrder" :disabled="editShow">确定</el-button>
            </el-form-item>
          </el-col>
        </el-col>
      </el-form>
    </SearchBox>
    <el-tabs v-model="activeName">
      <!--安灯工单日志-->
      <el-tab-pane label="安灯工单日志" name="first">
        <LabelContent title="安灯工单日志" ref="LabelContent" />
        <div class="tableBox">
          <el-table ref="multipleTable" stripe :data="logList" class="center">
            <el-table-column prop="aolTitle" label="记录标题" show-overflow-tooltip />
            <el-table-column prop="aolContent" label="记录内容" show-overflow-tooltip />
            <el-table-column prop="createUserName" label="创建人姓名" show-overflow-tooltip />
            <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip />
          </el-table>
        </div>
      </el-tab-pane>
      <!--安灯验收日志-->
      <el-tab-pane label="安灯验收日志" name="second">
        <LabelContent title="安灯验收日志" ref="LabelContent" />
        <el-table ref="multipleTable" stripe :data="checkList" class="center">
          <el-table-column prop="checkItemName" label="项目名称" />
          <el-table-column prop="checkItemBenchmark" label="基准值" />
          <el-table-column prop="checkUserName" label="确认人" />
          <el-table-column prop="createTime" label="确认时间" width="160" />
          <el-table-column prop="checkValue1" label="测定值1" />
          <el-table-column prop="checkValue2" label="测定值2" />
          <el-table-column prop="checkValue3" label="测定值3" />
          <el-table-column prop="checkValue4" label="测定值4" />
          <el-table-column prop="checkValue5" label="测定值5" />
          <el-table-column prop="checkValue6" label="测定值6" />
          <el-table-column prop="checkValue7" label="测定值7" />
          <el-table-column prop="checkValue8" label="测定值8" />
          <el-table-column prop="andonCheckImg" label="验收图片">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: 100px" :src="scope.row.andonCheckImg.split(',')[0]" :preview-src-list="scope.row.andonCheckImg.split(',')">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="isNormal" label="是否异常">
            <template slot-scope="scope">
              <span>{{ scope.row.isNormal == true ? '是' : '否' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import {
  getAndonOrderCheckAndonCode,
  getAndonOrderLogAndonCode,
  getAndonOrderResp,
  getAndonRuleTrigger
} from '../../../libs/api'
import moment from 'moment'

export default {
  name: 'andonOrderDetail',
  data() {
    return {
      imgSList: [],
      picList: [],
      logList: [],
      checkList: [],
      searchParams: {},
      // 工厂数据树
      factoryTree: [],
      activeName: 'first',
      editShow: false,
      orgShow: true,
      fcIdSelected: '',
      sectionSelected: '',
      shopSelected: '',
      lineSelected: '',
      // 安灯类型树
      andonTypelist: [],
      aTypeSelected: '',
      aCSelected: '',
      ruleTriggerList: [],
      deviceInfoList: [],
      deviceFcCode: '',
      faultTreeList: [],
      faultTreeOne: [],
      faultTreeOneText: [],
      faultTreeOneValue: '',
      faultTreeTwo: [],
      faultTreeTwoText: [],
      faultTreeTwoValue: '',
      faultTreethree: [],
      faultTreethreeText: [],
      faultTreethreeValue: '',
      faultCode: ''
    }
  },
  computed: {
    factoryList: function () {
      var arr = []
      if (this.factoryTree != undefined && this.factoryTree.length > 0) {
        for (var i = 0; i < this.factoryTree.length; i++) {
          arr.push({
            label: this.factoryTree[i].deptName,
            id: this.factoryTree[i].deptID,
            value: JSON.stringify(this.factoryTree[i]),
            deptLevel: this.factoryTree[i].deptLevel,
            parent: 0
          })
        }
      }
      return arr
    },
    shopList: function () {
      var arr = []
      if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
        var factory = JSON.parse(this.fcIdSelected)
        var shops = factory.child
        for (var i = 0; i < shops.length; i++) {
          if (shops[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: shops[i].deptName,
              id: shops[i].deptID,
              value: JSON.stringify(shops[i]),
              deptLevel: shops[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    sectionList: function () {
      var arr = []
      if (this.shopSelected != undefined && this.shopSelected.length > 0) {
        var shop = JSON.parse(this.shopSelected)
        var vsms = shop.child
        for (var i = 0; i < vsms.length; i++) {
          if (vsms[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: vsms[i].deptName,
              id: vsms[i].deptID,
              value: JSON.stringify(vsms[i]),
              deptLevel: vsms[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    lineList: function () {
      var arr = []
      if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
        var vsm = JSON.parse(this.sectionSelected)
        var lines = vsm.child
        for (var i = 0; i < lines.length; i++) {
          if (lines[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: lines[i].deptName,
              id: lines[i].deptID,
              value: JSON.stringify(lines[i]),
              deptLevel: lines[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    // 安灯类型下拉列表
    aTList: function () {
      var arr = []
      if (this.andonTypelist != undefined && this.andonTypelist.length > 0) {
        for (var i = 0; i < this.andonTypelist.length; i++) {
          arr.push({
            label: this.andonTypelist[i].typeName,
            id: this.andonTypelist[i].id,
            value: this.andonTypelist[i],
            parent: 0
          })
        }
      }
      return arr
    },
    aCList: function () {
      var arr = []
      if (this.aTypeSelected != undefined && this.aTypeSelected.length > 0) {
        var aContent = JSON.parse(this.aTypeSelected)
        var content = aContent.contentList
        if (content != undefined) {
          for (var i = 0; i < content.length; i++) {
            arr.push({
              label: content[i].content,
              id: content[i].id,
              value: JSON.stringify(content[i]),
              parent: 0
            })
          }
        }
      }
      return arr
    }
  },
  created() {
    this.init()
  },
  /*mounted() {
      this.init()
  },*/
  methods: {
    init() {
      if (this.$route.params.AndonOrder != undefined && this.$route.params.AndonOrder != '') {
        this.searchParams = this.$route.params.AndonOrder
        sessionStorage.setItem('AndonOrder', JSON.stringify(this.searchParams))
      } else {
        this.searchParams = JSON.parse(sessionStorage.getItem('AndonOrder'))
      }
      if (this.searchParams.andonStatus != 'complete') {
        this.editShow = true
      } else {
        if (this.searchParams.hasOwnProperty('devCode')) {
          this.orgShow = true
        } else {
          this.orgShow = false
        }
        this.editShow = false
      }
      this.deviceFcCode = this.searchParams.fcCode
      this.getData()
      this.getAndonType()
      this.queryAndonOrderResp()
      this.queryAndonOrderLog()
      this.queryAndonOrderCheck()
      this.getDeviceInfoList()
    },
    aTChange() {
      this.aCSelected = ''
      this.searchParams.arId = ''
      this.searchParams.arLevel = ''
    },
    aCChange() {
      this.searchParams.acCode = JSON.parse(this.aCSelected).acCode
      this.searchParams.arId = ''
      this.getAndonRuleTrigger()
    },
    getDeviceInfoList() {
      let queryParams = {
        fcCode: this.searchParams.fcCode
      }
      let options = {
        method: 'GET',
        url: this.$api.deviceInfoList,
        params: queryParams
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.deviceInfoList = response.data
        }
      })
    },
    getAndonType() {
      let options = {
        method: 'GET',
        url: this.$api.getAndonRule,
        params: {
          fcCode: this.searchParams.fcCode
        }
      }
      let self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.andonTypelist = response.data
          for (var i = 0; i < self.andonTypelist.length; i++) {
            var aTypes = self.andonTypelist[i]
            if (aTypes.id == self.searchParams.atId) {
              self.aTypeSelected = JSON.stringify(aTypes)
            }
            var aCTypes = aTypes.contentList
            if (aCTypes != undefined && aCTypes != '') {
              for (var j = 0; j < aCTypes.length; j++) {
                if (aCTypes[j].id == self.searchParams.acId) {
                  self.aCSelected = JSON.stringify(aCTypes[j])
                }
              }
            }
          }
          self.getAndonRuleTrigger()
        }
      })
    },
    ruleTriggerChange() {
      if (this.searchParams.arId != null && this.searchParams.arId != '') {
        for (let i = 0; i < this.ruleTriggerList.length; i++) {
          if (this.searchParams.arId == this.ruleTriggerList[i].arId) {
            this.searchParams.arLevel = this.ruleTriggerList[i].arLevel
            this.searchParams.arTrigger = this.ruleTriggerList[i].arTrigger
          }
        }
      } else {
        this.searchParams.arLevel = ''
      }
    },
    getAndonRuleTrigger() {
      let queryParams = {
        acCode: this.searchParams.acCode,
        fcCode: this.searchParams.fcCode
      }
      let options = {
        method: 'GET',
        url: this.$api.getAndonRuleTrigger,
        params: queryParams
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.ruleTriggerList = response.data
        }
      })
    },
    shopChange: function () {
      this.sectionSelected = ''
      this.lineSelected = ''
    },
    sectionChange: function () {
      this.lineSelected = ''
    },
    queryAndonOrderResp() {
      let queryParams = {
        andonCode: this.searchParams.andonCode
      }
      let options = {
        method: 'GET',
        url: this.$api.getAndonOrderResp,
        params: queryParams
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data != undefined && response.data != '') {
            this.faultCode = response.data[0].faultCode
            console.log(this.faultCode)
            this.searchParams = {}
            this.searchParams = JSON.parse(JSON.stringify(response.data[0]))
            console.log('queryAndonOrderResp,this.searchParams', this.searchParams)
            this.searchParams.moAdjustProdTime = Math.ceil(this.searchParams.moAdjustProdTime / 60)
            this.searchParams.moProbTime = Math.ceil(this.searchParams.moProbTime / 60)
            this.imgSList = []
            this.picList = []
            if (this.searchParams.aorSolveImg != '' && this.searchParams.aorSolveImg != undefined) {
              let arr = this.searchParams.aorSolveImg.split(',')
              for (let i = 0; i < arr.length; i++) {
                this.imgSList.push(arr[i])
              }
            }
            if (this.searchParams.andonProbImg != '' && this.searchParams.andonProbImg != undefined) {
              let array = this.searchParams.andonProbImg.split(',')
              for (let j = 0; j < array.length; j++) {
                this.picList.push(array[j])
              }
            }
          }
        }
        this.getFaultCodeThreeTree()
      })
    },
    queryAndonOrderLog() {
      let queryParams = {
        andonCode: this.searchParams.andonCode
      }
      let options = {
        method: 'GET',
        url: this.$api.getAndonOrderLogAndonCode,
        params: queryParams
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          self.logList = response.data
        }
      })
    },
    queryAndonOrderCheck() {
      let queryParams = {
        andonCode: this.searchParams.andonCode
      }
      let options = {
        method: 'GET',
        url: this.$api.getAndonOrderCheckAndonCode,
        params: queryParams
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          self.checkList = response.data
        }
      })
    },
    editAndonOrder() {
      /*if(this.searchParams.andonStatus != 'complete'){
          this.$message.error("当前工单不能修改！")
          return;
      }*/
      let queryParams = {}
      if (this.fcIdSelected == undefined || this.fcIdSelected == '') {
        this.$message.info('请选择工厂！')
        return
      }
      if (this.shopSelected == undefined || this.shopSelected == '') {
        this.$message.info('请选择车间！')
        return
      }
      if (this.sectionSelected == undefined || this.sectionSelected == '') {
        this.$message.info('请选择工段！')
        return
      }
      if (this.lineSelected == undefined || this.lineSelected == '') {
        this.$message.info('请选择产线！')
        return
      }
      /*if(this.searchParams.devCode == undefined || this.searchParams.devCode == ''){
          this.$message.info("请输入设备编号！")
          return;
      }
      if(this.searchParams.devName == undefined || this.searchParams.devName == ''){
          this.$message.info("请输入设备名称！")
          return;
      }*/
      /*if(this.orgShow != true){
          this.$message.info("请输入正确的设备编号！")
          return;
      }*/
      if (this.aTypeSelected == undefined || this.aTypeSelected == '') {
        this.$message.info('请选择安灯类型！')
        return
      }
      if (this.aCSelected == undefined || this.aCSelected == '') {
        this.$message.info('请选择安灯种类！')
        return
      }
      if (this.searchParams.arId == undefined || this.searchParams.arId == '') {
        this.$message.info('请选择安灯规则！')
        return
      }
      if (this.searchParams.andonProbDesc == undefined || this.searchParams.andonProbDesc == '') {
        this.$message.info('请输入问题描述！')
        return
      }
      /*if(this.searchParams.pubUserName == undefined || this.searchParams.pubUserName == ''){
          this.$message.info("请输入发布人！")
          return;
      }*/
      /*if(this.searchParams.andonRespUserName == undefined || this.searchParams.andonRespUserName == ''){
          this.$message.info("请输入接单人！")
          return;
      }*/
      if (this.searchParams.createTime == undefined || this.searchParams.createTime == '') {
        this.$message.info('请选择发布时间！')
        return
      }
      /*if(this.searchParams.andonRespTime == undefined || this.searchParams.andonRespTime == ''){
          this.$message.info("请选择接单时间！")
          return;
      }
      if(this.searchParams.moRepairStart == undefined || this.searchParams.moRepairStart == ''){
          this.$message.info("请选择维修开始时间！")
          return;
      }
      if(this.searchParams.moRepairEnd == undefined || this.searchParams.moRepairEnd == ''){
          this.$message.info("请选择维修结束时间！")
          return;
      }
      if(this.searchParams.andonRejectReason == undefined || this.searchParams.andonRejectReason == ''){
          this.$message.info("请输入安灯退回原因！")
          return;
      }
      if(this.searchParams.morAssistOne == undefined || this.searchParams.morAssistOne == ''){
          this.$message.info("请输入协助人员一！")
          return;
      }
      if(this.searchParams.morAssistTwo == undefined || this.searchParams.morAssistTwo == ''){
          this.$message.info("请输入协助人员二！")
          return;
      }
      if(this.searchParams.morAssistThree == undefined || this.searchParams.morAssistThree == ''){
          this.$message.info("请输入协助人员三！")
          return;
      }
      if(this.searchParams.aorReasonType == undefined || this.searchParams.aorReasonType == ''){
          this.$message.info("请输入原因分类！")
          return;
      }
      if(this.searchParams.analyzingDesc == undefined || this.searchParams.analyzingDesc == ''){
          this.$message.info("请输入原因分析描述！")
          return;
      }
      if(this.searchParams.aorSolveDesc == undefined || this.searchParams.aorSolveDesc == ''){
          this.$message.info("请输入处理对策描述！")
          return;
      }
      if(this.searchParams.empActionType == undefined || this.searchParams.empActionType == ''){
          this.$message.info("请输入紧急措施类型！")
          return;
      }
      if(this.searchParams.empActionDesc == undefined || this.searchParams.empActionDesc == ''){
          this.$message.info("请输入紧急措施描述！")
          return;
      }*/
      var self = this
      queryParams = {
        //安灯工单
        andonId: self.searchParams.andonId,
        andonCode: self.searchParams.andonCode,
        fcCode: JSON.parse(self.fcIdSelected).deptCode,
        fcName: JSON.parse(self.fcIdSelected).deptName,
        shopCode: JSON.parse(self.shopSelected).deptCode,
        shopName: JSON.parse(self.shopSelected).deptName,
        sectionCode: JSON.parse(self.sectionSelected).deptCode,
        sectionName: JSON.parse(self.sectionSelected).deptName,
        lineCode: JSON.parse(self.lineSelected).deptCode,
        lineName: JSON.parse(self.lineSelected).deptName,
        devCode: self.searchParams.devCode,
        devName: self.searchParams.devName,
        atName: JSON.parse(self.aTypeSelected).typeName,
        acName: JSON.parse(self.aCSelected).content,
        arTrigger: self.searchParams.arTrigger,
        arId: self.searchParams.arId,
        arLevel: self.searchParams.arLevel,
        andonProbDesc: self.searchParams.andonProbDesc,
        pubUserName: self.searchParams.pubUserName,
        andonRespUserName: self.searchParams.andonRespUserName,
        createTime: moment(self.searchParams.createTime).format('YYYY-MM-DD HH:mm:ss'),
        andonRejectReason: self.searchParams.andonRejectReason,
        //安灯验收日志
        aorId: self.searchParams.aorId,
        morAssistOne: self.searchParams.morAssistOne,
        morAssistTwo: self.searchParams.morAssistTwo,
        morAssistThree: self.searchParams.morAssistThree,
        aorReasonType: self.searchParams.aorReasonType,
        analyzingDesc: self.searchParams.analyzingDesc,
        aorSolveDesc: self.searchParams.aorSolveDesc,
        empActionType: self.searchParams.empActionType,
        empActionDesc: self.searchParams.empActionDesc,
        moAdjustProdTime: self.searchParams.moAdjustProdTime,
        faultCode: self.faultCode
      }
      queryParams['aorIsContain'] = self.searchParams.aorIsContain
      queryParams['empActionConfirm'] = self.searchParams.empActionConfirm
      queryParams['morIsSupport'] = self.searchParams.morIsSupport
      if (self.searchParams.andonRespTime != undefined && self.searchParams.andonRespTime != '') {
        queryParams['andonRespTime'] = moment(self.searchParams.andonRespTime).format('YYYY-MM-DD HH:mm:ss')
      }
      if (self.searchParams.moRepairStart != undefined && self.searchParams.moRepairStart != '') {
        queryParams['moRepairStart'] = moment(self.searchParams.moRepairStart).format('YYYY-MM-DD HH:mm:ss')
      }
      if (self.searchParams.moRepairEnd != undefined && self.searchParams.moRepairEnd != '') {
        queryParams['moRepairEnd'] = moment(self.searchParams.moRepairEnd).format('YYYY-MM-DD HH:mm:ss')
      }
      let options = {
        method: 'POST',
        url: this.$api.editAndonOrder,
        data: queryParams
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.$message.success('编辑成功！')
          this.queryAndonOrderResp()
          this.queryAndonOrderLog()
        } else {
          this.$message.error('编辑失败！')
        }
      })
    },
    queryDevCode() {
      if (this.searchParams.devCode == undefined || this.searchParams.devCode == '') {
        this.$message.error('设备编号为空！')
        this.searchParams.fcCode = ''
        this.searchParams.shopCode = ''
        this.searchParams.sectionCode = ''
        this.searchParams.lineCode = ''
        this.searchParams.devName = ''
        this.orgShow = false
        this.$nextTick(() => {
          this.getData()
        })
        return
      }
      let options = {
        method: 'get',
        url: this.$api.queryDevCode,
        params: {
          devCode: this.searchParams.devCode
        }
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.hasOwnProperty('data')) {
            this.searchParams.fcCode = response.data.fcCode
            this.searchParams.shopCode = response.data.shopCode
            this.searchParams.sectionCode = response.data.sectionCode
            this.searchParams.lineCode = response.data.lineCode
            this.searchParams.devName = response.data.devName
            this.orgShow = true
            this.$nextTick(() => {
              this.getData()
            })
          } else {
            this.searchParams.fcCode = ''
            this.searchParams.shopCode = ''
            this.searchParams.sectionCode = ''
            this.searchParams.lineCode = ''
            this.searchParams.devName = ''
            this.orgShow = false
            this.$message.error('设备号不存在！')
            this.$nextTick(() => {
              this.getData()
            })
          }
        }
      })
    },
    getFaultCodeThreeTree() {
      let options = {
        method: 'get',
        url: this.$api.faultCodeThreeTree,
        params: {
          fcCode: this.searchParams.fcCode
        }
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data != undefined && response.data != '') {
            this.faultTreeList = response.data
          }
          this.faultCodes()
        }
      })
    },
    getFaultCodeThreeOne() {
      let that = this
      let arr = []
      let faultTreeList = this.faultTreeList
      for (let i = 0; i < faultTreeList.length; i++) {
        arr.push({
          grandpaname: faultTreeList[i].faultName, //名称
          grandpacode: faultTreeList[i].faultCode, //Code
          grandpaparentId: faultTreeList[i].parentId, //父类id
          grandpafaultId: faultTreeList[i].faultId, //id
          value: JSON.stringify(faultTreeList[i]),
          parent: 0
        })
      }
      this.faultTreeOne = arr
      this.getFaultCodeThreeTwo()
    },
    faultTreeOneValues(value) {
      this.faultTreeOneValue = value
      this.getFaultCodeThreeTwo()
      this.faultTreeTwoText = ''
    },
    getFaultCodeThreeTwo() {
      let that = this
      let arr = []
      let faultTreeTwo = JSON.parse(that.faultTreeOneValue)
      for (let i = 0; i < faultTreeTwo.child.length; i++) {
        arr.push({
          grandpaname: faultTreeTwo.child[i].faultName, //名称
          grandpacode: faultTreeTwo.child[i].faultCode, //Code
          grandpaparentId: faultTreeTwo.child[i].parentId, //父类id
          grandpafaultId: faultTreeTwo.child[i].faultId, //id
          value: JSON.stringify(faultTreeTwo.child[i]),
          parent: 0
        })
      }
      this.faultTreeTwo = arr
      console.log(this.faultTreeTwo)
      this.getFaultCodeThreethree()
    },
    faultTreeTwoValues(value) {
      this.faultTreeTwoValue = value
      this.getFaultCodeThreethree()
      this.faultTreethreeText = ''
    },
    getFaultCodeThreethree() {
      let that = this
      let arr = []
      let faultTreethree = JSON.parse(that.faultTreeTwoValue)
      for (let i = 0; i < faultTreethree.child.length; i++) {
        arr.push({
          grandpaname: faultTreethree.child[i].faultName, //名称
          grandpacode: faultTreethree.child[i].faultCode, //Code
          grandpaparentId: faultTreethree.child[i].parentId, //父类id
          grandpafaultId: faultTreethree.child[i].faultId, //id
          value: JSON.stringify(faultTreethree.child[i]),
          parent: 0
        })
      }
      this.faultTreethree = arr
      console.log(this.faultTreethree)
    },
    faultTreethreeValues(value) {
      this.faultTreethreeValue = value,
        this.faultCode = value
    },
    faultCodes() {
      let that = this
      let fault = that.faultTreeList
      let sonCode = that.faultCode //第三类故障代码Code
      console.log(that.faultCode)
      let sonparentId = '' //三类父级id
      let daddyparentId = '' //二类父级id
      for (let a = 0; a < fault.length; a++) {
        for (let b = 0; b < fault[a].child.length; b++) {
          for (let c = 0; c < fault[a].child[b].child.length; c++) {
            if (sonCode == fault[a].child[b].child[c].faultCode) {
              sonparentId = fault[a].child[b].child[c].parentId
              that.faultTreethreeText = fault[a].child[b].child[c].faultName
              console.log(fault[a].child[b].child[c].faultName)
            }
          }
        }
      }
      for (let a2 = 0; a2 < fault.length; a2++) {
        for (let b2 = 0; b2 < fault[a2].child.length; b2++) {
          if (sonparentId == fault[a2].child[b2].faultId) {
            daddyparentId = fault[a2].child[b2].parentId
            that.faultTreeTwoText = fault[a2].child[b2].faultName
            console.log(fault[a2].child[b2].faultName)
          }
        }
      }
      for (let a3 = 0; a3 < fault.length; a3++) {
        if (daddyparentId == fault[a3].faultId) {
          that.faultTreeOneText = fault[a3].faultName
          console.log(fault[a3].faultName)
        }
      }
      this.getFaultCodeThreeOne()
    },
    getData() {
      let options = {
        method: 'GET',
        url: this.$api.departTree,
        params: {
          fcCode: this.deviceFcCode
        }
      }
      let self = this
      this.$http.request(options).then(response => {
        self.factoryTree = response.data
        for (var i = 0; i < self.factoryTree.length; i++) {
          var factorys = self.factoryTree[i]
          if (factorys.hasOwnProperty('deptCode')) {
            if (factorys.deptCode == self.searchParams.fcCode) {
              self.fcIdSelected = JSON.stringify(factorys)
            }
          }
          var shop = factorys.child
          for (var j = 0; j < shop.length; j++) {
            if (shop[j].hasOwnProperty('deptCode')) {
              if (shop[j].deptCode == self.searchParams.shopCode) {
                self.shopSelected = JSON.stringify(shop[j])
              }
            }
            var vsm = shop[j].child
            for (var v = 0; v < vsm.length; v++) {
              if (vsm[v].hasOwnProperty('deptCode')) {
                if (vsm[v].deptCode == self.searchParams.sectionCode) {
                  self.sectionSelected = JSON.stringify(vsm[v])
                }
              }
              var line = vsm[v].child
              for (var l = 0; l < line.length; l++) {
                if (line[l].hasOwnProperty('deptCode')) {
                  if (line[l].deptCode == self.searchParams.lineCode) {
                    self.lineSelected = JSON.stringify(line[l])
                  }
                }
              }
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .upload-files {
      width: 300px;
  }

  ::v-deep .el-textarea__inner {
      width: 72vw !important;
  }
</style>
